export default __webpack_public_path__ + "static/media/3.9c6a16aa.png";